import { Timer, Callback } from './Timer';

export class TimeEvents {
  private timers: Timer[] = [];

  public wait(timeMs: number): Promise<void> {
    return new Promise((resolve) => this.add(timeMs, resolve));
  }

  public add(timeMs: number, callback: Callback): Timer {
    const timer: Timer = new Timer(timeMs, 0, callback);
    this.timers.push(timer);
    return timer;
  }

  public repeat(timeMs: number, count: number, callback: Callback): Timer {
    const timer: Timer = new Timer(timeMs, count, callback);
    this.timers.push(timer);
    return timer;
  }

  public loop(timeMs: number, callback: Callback): Timer {
    const timer: Timer = new Timer(timeMs, -1, callback);
    this.timers.push(timer);
    return timer;
  }

  public update(deltaMs: number): void {
    let anyTimerDestroyed: boolean = false;
    for (let i = 0; i < this.timers.length; i++) {
      this.timers[i].update(deltaMs);
      if (this.timers[i].destroyed) anyTimerDestroyed = true;
    }

    if (anyTimerDestroyed) this.removeDestroyedTimers();
  }

  private removeDestroyedTimers(): void {
    this.timers = this.timers.filter((timer) => !timer.destroyed);
  }

  public removeAll(): void {
    this.timers.forEach((timer) => timer.destroy());
    this.timers.length = 0;
  }
}
